var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!_vm.quizStarted)?_c('quiz-intro'):(_vm.quizRunning)?_c('questions'):_c('quiz-finished')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }